import Axios from "axios";
import config from "../app.config";

export var mailSentFailedService
export default mailSentFailedService = {
    getListMailSentFailed,
    
}

// list function

async function getListMailSentFailed(data) {
    let mailBox = data.mailBox
    let queries = data.queries
    return await Axios.get(`${config.LOCAL_API_URL}/getListMailSentFailed/${mailBox}`, {params: queries})
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}

